/**
 * Show messages
 */
var autoCloseMessage;

function showMessage(messageHtml) {
	clearTimeout(autoCloseMessage);

	const messageContainer = document.getElementById('messages-container');
	messageContainer.classList.add('hidden-message-item');

	messageContainer.innerHTML = messageHtml;

	setTimeout(() => {
		messageContainer.classList.remove('hidden-message-item');
	}, 100);

	/**
	 * Auto close after 5 seconds
	 */
	autoCloseMessage = setTimeout(() => {
		messageContainer.classList.add('hidden-message-item');
	}, 5000);
}

/**
 * Messages component
 */
class MessageItem extends HTMLElement {
	constructor() {
		super();

		const closeButton = this.querySelector('.close-message');
		closeButton.addEventListener('click', this.closeMessage.bind(this));
	}

	closeMessage() {
		const messagesContainer = this.closest('.messages-container');
		messagesContainer.classList.add('hidden-message-item');
	}
}

customElements.define('tpt-message-item', MessageItem);

/**
 * Modal component
 */

class ModalComponent extends HTMLElement {
	constructor() {
		super();

		const currentModalId = this.getAttribute('id');
		const btnOpenElement = document.querySelectorAll('a[data-modal-target="' + currentModalId + '"]');
		const closeModalButton = this.querySelectorAll('[data-close="modal"]');
		const dontShowButton = this.querySelector('tpt-dont-show');
		const modalHeader = this.querySelector('tpt-modal-header');

		modalHeader.addEventListener('touchmove', this.closeModal);
		this.addEventListener('click', this.closeModalComponent);
		this.addEventListener('keydown', this.keyDown.bind(this));

		btnOpenElement.forEach((element) => {
			element.addEventListener('click', this.showModal.bind(this));
		});

		if (dontShowButton) {
			dontShowButton.addEventListener('click', this.dontShowModalAgain);
		}

		if (sessionStorage.getItem('modal-dont-show-' + currentModalId) === 'false' || sessionStorage.getItem('modal-dont-show-' + currentModalId) === null) {
			if (this.getAttribute('data-auto-open') == 'true') {
				let timeDelay = 0;
				const autoOpenModal = this;

				if (autoOpenModal.getAttribute('data-time-delay')) {
					timeDelay = autoOpenModal.getAttribute('data-time-delay') * 1000;
				}

				setTimeout(function () {
					autoOpenModal.classList.add('show');
					document.getElementsByTagName('html')[0].classList.add('open-modal');
				}, timeDelay);
			}
		}

		closeModalButton.forEach((element) => {
			element.addEventListener('click', this.closeModal);
		});
	}

	showModal(e) {
		e.preventDefault();

		const modalId = this.getAttribute('id');
		const btnOpenModal = document.querySelector('[data-modal-target="' + modalId + '"]');

		if (btnOpenModal.classList.contains('active')) {
			btnOpenModal.classList.remove('active');
			btnOpenModal.setAttribute('aria-expanded', false);
			document.getElementsByTagName('html')[0].classList.remove('open-modal');
			this.classList.remove('show');

			setTimeout(() => {
				document.getElementById(modalId).focus();
			}, 300);

			return;
		} else {
			btnOpenModal.classList.add('active');
			btnOpenModal.setAttribute('aria-expanded', true);
			document.getElementsByTagName('html')[0].classList.add('open-modal');
			this.classList.add('show');

			setTimeout(() => {
				document.getElementById(modalId).focus();
			}, 300);

			this.scrollTop = 0;

			return;
		}
	}

	keyDown(e) {
		if (e.keyCode === 27) {
			this.closeModal();
		}

		if (e.keyCode === 9) {
			const currentModal = this;

			setTimeout(() => {
				const focusItem = document.activeElement;

				if (!focusItem.closest('tpt-modal-component') || focusItem.tagName == 'BODY') {
					currentModal.querySelector('[tabindex]').focus();
				}
			}, 200);
		}
	}

	closeModal() {
		const closeButton = this;

		const currentModalId = this.closest('tpt-modal-component').getAttribute('id');
		const btnDontShow = this.closest('tpt-modal-component').querySelector('tpt-dont-show');

		if (btnDontShow) {
			if (btnDontShow.classList.contains('active')) {
				sessionStorage.setItem('modal-dont-show-' + currentModalId, 'true');
			} else {
				sessionStorage.setItem('modal-dont-show-' + currentModalId, 'false');
			}
		}

		this.closest('tpt-modal-component').classList.remove('show');

		const buttonModal = document.querySelectorAll('[data-modal-target="' + currentModalId + '"]');

		if (buttonModal) {
			buttonModal.forEach((buttonTarget) => {
				buttonTarget.classList.remove('active');
				buttonTarget.setAttribute('aria-expanded', false);
			});
		}

		setTimeout(function () {
			const modalCount = document.querySelectorAll('tpt-modal-component.show').length;

			if (modalCount < 1) {
				document.getElementsByTagName('html')[0].classList.remove('open-modal');
			}
		}, 200);

		setTimeout(function () {
			if (closeButton.closest('tpt-modal-component').classList.contains('quickview-modal')) {
				if (document.getElementById(currentModalId)) {
					document.getElementById(currentModalId).remove();
				}
			}

			if (closeButton.closest('tpt-modal-component').classList.contains('tpt-product-live__modal')) {
				closeButton.closest('tpt-modal-component').remove();
			}
		}, 400);
	}

	closeModalComponent(e) {
		if (e.target !== this) {
			return;
		} else {
			this.closeModal();
		}
	}

	dontShowModalAgain() {
		this.classList.toggle('active');
	}
}

customElements.define('tpt-modal-component', ModalComponent);

class OpenModalComponent extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', this.openModal);
		this.addEventListener('keypress', this.keyPress);
	}

	keyPress(e) {
		if (e.key === 'Enter') {
			this.openModal(e);
		}
	}

	openModal(e) {
		e.preventDefault();

		const modalId = this.getAttribute('data-modal-target');
		const modalComponent = document.getElementById(modalId);

		//const btnOpenModal = this;

		if (this.classList.contains('active')) {
			this.classList.remove('active');

			this.setAttribute('aria-expanded', false);

			document.getElementsByTagName('html')[0].classList.remove('open-modal');
			modalComponent.classList.remove('show');

			setTimeout(() => {
				modalComponent.focus();
			}, 300);

			return;
		} else {
			this.classList.add('active');

			this.setAttribute('aria-expanded', true);

			document.getElementsByTagName('html')[0].classList.add('open-modal');
			modalComponent.classList.add('show');

			setTimeout(() => {
				modalComponent.focus();
			}, 300);

			return;
		}
	}
}

customElements.define('tpt-open-modal', OpenModalComponent);

/**
 * Init swiper slider
 */
class SwiperSliderComponent extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		const swiper = this.querySelector('.swiper');
		const optionString = this.querySelector('tpt-slider-options').innerHTML;
		const optionsJson = JSON.parse(optionString);
		const nextButton = this.querySelector('.swiper-button-next');
		const prevButton = this.querySelector('.swiper-button-prev');

		let options = {
			...optionsJson,
			navigation: {
				nextEl: nextButton,
				prevEl: prevButton,
			},
		};

		new Swiper(swiper, options);
	}
}

customElements.define('tpt-slider-component', SwiperSliderComponent);

/**
 * Quickview product
 */

class ProductQuickview extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('click', this.showQuickview.bind(this));
		this.addEventListener('keypress', this.keyPress);
	}

	keyPress(e) {
		if (e.key === 'Enter') {
			this.showQuickview();
		}
	}

	showQuickview() {
		var productUrl = this.getAttribute('data-product-url');
		const productId = this.getAttribute('data-product-id');
		const productTitle = this.getAttribute('data-product-title');
		const variantSelected = this.getAttribute('data-variant-id');

		if (variantSelected) {
			productUrl = productUrl + `?variant=${variantSelected}`;
		}

		if (this.closest('cart-drawer')) {
			this.closest('cart-drawer').classList.remove('animate', 'active');
			document.body.classList.remove('overflow-hidden');
		}

		let modalHtml = '';
		modalHtml += '<tpt-modal-component id="product-modal_id-' + productId + '" class="quickview-modal fade" data-position="right" role="dialog" aria-modal="true" data-modal-product-id="' + productId + '" tabindex="-1">';
		modalHtml += '<tpt-modal-dialog class="color-scheme-1 gradient" style="max-width: 500px">';
		modalHtml += '<tpt-modal-content>';

		modalHtml += '<tpt-modal-header>';
		modalHtml += '<div class="modal-title">';
		modalHtml += productTitle;
		modalHtml += '</div>';

		modalHtml += '<button class="close-modal" data-close="modal" tabindex="0">';
		modalHtml += '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor"><path d="M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z"></path></svg>';
		modalHtml += '</button>';
		modalHtml += '</tpt-modal-header>';

		modalHtml += '<tpt-modal-body class="scroll-bar">';
		modalHtml += '<div class="modal-body_data-ajax modal-body_loading">';
		modalHtml += '<div class="loader-component"><span class="hidden">Loading...</span></div>';
		modalHtml += '</div>';
		modalHtml += '</tpt-modal-body>';

		modalHtml += '</tpt-modal-content>';
		modalHtml += '</tpt-modal-dialog>';
		modalHtml += '</tpt-modal-component>';

		if (document.getElementById('product-modal_id-' + productId)) {
			this.showModal('product-modal_id-' + productId);
		} else {
			//this.classList.add('loading');
			document.body.insertAdjacentHTML('afterbegin', modalHtml);
			document.getElementsByTagName('html')[0].classList.add('open-modal');

			setTimeout(function () {
				document.getElementById('product-modal_id-' + productId).classList.add('show');
			}, 200);

			fetch(productUrl)
				.then((response) => response.text())
				.then((responseText) => {
					const productModal = document.getElementById('product-modal_id-' + productId);
					const productContainer = productModal.querySelector('.modal-body_data-ajax');
					const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
					const productElement = responseHTML.querySelector('section[id^="MainProduct-"]');

					if (responseHTML.querySelector('variant-selects')) {
						const sectionId = responseHTML.querySelector('variant-selects').getAttribute('data-section');

						productContainer.innerHTML = productElement.innerHTML.replaceAll(sectionId, `tpt-quickview-${sectionId}`);

						productContainer.querySelectorAll('variant-selects, product-info').forEach((element) => {
							element.setAttribute('data-section', sectionId);
						});
					} else {
						productContainer.innerHTML = productElement.innerHTML;
					}

					if (window.Shopify && Shopify.PaymentButton) {
						Shopify.PaymentButton.init();
					}

					if (window.ProductModel) window.ProductModel.loadShopifyXR();
					this.preventVariantURLSwitching();

					productContainer.querySelectorAll('script').forEach((oldScriptTag) => {
						const newScriptTag = document.createElement('script');
						Array.from(oldScriptTag.attributes).forEach((attribute) => {
							newScriptTag.setAttribute(attribute.name, attribute.value);
						});
						newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
						oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
					});
				})
				.finally(() => {
					const productModal = document.getElementById('product-modal_id-' + productId);

					//this.classList.remove('loading');
					productModal.querySelector('.modal-body_data-ajax').classList.remove('modal-body_loading');
					productModal.classList.add('quickview-loaded');

					setTimeout(() => {
						productModal.focus();
					}, 50);
				});
		}
	}

	showModal(modalId) {
		document.getElementById(modalId).classList.add('show');
		document.getElementsByTagName('html')[0].classList.add('open-modal');
	}

	preventVariantURLSwitching() {
		const productId = this.getAttribute('data-product-id');
		const productModal = document.getElementById('product-modal_id-' + +productId);
		const variantPicker = productModal.querySelector('variant-selects');
		if (!variantPicker) return;

		variantPicker.setAttribute('data-update-url', 'false');
	}
}

customElements.define('tpt-quickview', ProductQuickview);

/**
 * Popup inner product variants
 */
class PopupVariantsInner extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('click', this.showVariantsPopup.bind(this));
	}

	showVariantsPopup() {
		let productUrl = this.getAttribute('data-product-url');
		const productId = this.getAttribute('data-product-id');
		const productElement = this.closest('.product-card-wrapper');

		const variantModals = document.querySelectorAll('tpt-modal-variants');

		variantModals.forEach((modalItem) => {
			modalItem.remove();
		});

		if (productUrl.toLowerCase().includes('pr_prod_strat')) {
			const urlArray = productUrl.split('?pr_prod_strat');
			productUrl = urlArray[0] + '?section_id=tpt-variants';
		}

		let modalHtml = '';
		modalHtml += '<tpt-modal-variants id="variants-modal_id-' + productId + '" class="variants-modal scroll-bar fade show" role="dialog" aria-modal="true" tabindex="0">';
		modalHtml += '<div class="variants-content ' + window.product_variant_scheme + '">';
		modalHtml += '<button class="close-modal-variant" data-close="modal-variant"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor"><path d="M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z"></path></svg></button>';
		modalHtml += '<div class="variants-content-ajax">';
		modalHtml += '<div class="loading__spinner"> <svg class="spinner" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.0" viewBox="0 0 128 128" xml:space="preserve"><g><path d="M64 9.75A54.25 54.25 0 0 0 9.75 64H0a64 64 0 0 1 128 0h-9.75A54.25 54.25 0 0 0 64 9.75z" fill="currentColor"></path><animateTransform attributeName="transform" type="rotate" from="0 64 64" to="360 64 64" dur="800ms" repeatCount="indefinite"></animateTransform></g></svg></div>';
		modalHtml += '<div>';
		modalHtml += '<div>';
		modalHtml += '</tpt-modal-variants>';

		if (productElement.querySelector('tpt-modal-variants')) {
			this.closest('.product-card-wrapper').querySelector('tpt-modal-variants').classList.add('show');
		} else {
			this.classList.add('loading');
			const windowWith = window.innerWidth;

			if (windowWith <= 1024) {
				document.body.insertAdjacentHTML('beforeend', modalHtml);
			} else {
				this.closest('.product-card-wrapper').querySelector('.card__inner').insertAdjacentHTML('beforeend', modalHtml);
			}

			fetch(productUrl)
				.then((response) => response.text())
				.then((responseText) => {
					const modalElement = document.querySelector('tpt-modal-variants');
					const modalAjaxContent = modalElement.querySelector('.variants-content-ajax');

					modalAjaxContent.innerHTML = responseText;
				})
				.finally(() => {
					this.classList.remove('loading');

					setTimeout(() => {
						document.getElementById('variants-modal_id-' + productId).focus();
					}, 300);
				});
		}
	}
}

customElements.define('tpt-variants', PopupVariantsInner);

/**
 * Popup inner product variants
 */
class PopupVariantsModal extends HTMLElement {
	constructor() {
		super();

		const btnCloseModal = this.querySelector('[data-close="modal-variant"]');
		btnCloseModal.addEventListener('click', this.closeModalVariant.bind(this));
		this.addEventListener('click', this.closeModalVariantComponent);
		this.addEventListener('keydown', this.closeModalComponentEsc.bind(this));
	}

	closeModalComponentEsc(e) {
		if (e.keyCode === 27) {
			this.closeModalVariant();
		}
	}

	closeModalVariant() {
		const currentModal = this.closest('tpt-modal-component');
		//const currentModalCart = this.closest('cart-drawer');

		this.remove();

		if (currentModal) {
			currentModal.focus();
		}

		setTimeout(() => {
			document.querySelector('cart-drawer').cartFocus();
		}, 300);

		// if (currentModalCart) {
		// 	currentModalCart.focus();
		// }
	}

	closeModalVariantComponent(e) {
		if (e.target !== this) {
			return;
		} else {
			const windowWith = window.innerWidth;

			if (windowWith <= 1024) {
				this.remove();
			}
		}
	}
}
customElements.define('tpt-modal-variants', PopupVariantsModal);
/**
 * Tab popup component
 */

class PopupTabs extends HTMLElement {
	constructor() {
		super();

		const btnOpen = document.querySelectorAll('[data-tab-popup-target]');

		btnOpen.forEach((btnItem) => {
			btnItem.addEventListener('click', this.showModal);
		});
	}

	showModal(e) {
		e.preventDefault();

		const currentModalId = this.getAttribute('data-tab-popup-target');
		const currentModal = document.getElementById(currentModalId);
		const currentTabTrigger = this.getAttribute('data-item-tab-target');

		currentModal.querySelector('[data-tab-target="' + currentTabTrigger + '"]').click();

		document.getElementsByTagName('html')[0].classList.add('open-modal');
		currentModal.classList.add('show');
		this.scrollTop = 0;
	}
}

customElements.define('tpt-popup-tab', PopupTabs);

/**
 * Tabs component
 */
class TabItem extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('click', this.displayTabContainer.bind(this));
		this.addEventListener('keypress', this.keyPress.bind(this));
	}

	keyPress(event) {
		if (event.key === 'Enter') {
			this.displayTabContainer(event);
		}
	}

	displayTabContainer(event) {
		event.preventDefault();

		const tabContainerTarget = this.getAttribute('data-tab-target');
		const tabAjaxUrl = this.getAttribute('data-ajax-url');

		if (tabAjaxUrl && !this.classList.contains('loaded')) {
			this.closest('tpt-tabs-component').classList.add('component-loading');
			this.classList.add('loading');

			if (this.classList.contains('active')) {
				return;
			} else {
				const ajaxDataElement = this.closest('tpt-tabs-component').querySelector('[data-ajax-content="' + tabContainerTarget + '"]');

				fetch(tabAjaxUrl)
					.then((response) => response.text())
					.then((responseText) => {
						const elementToGet = this.getAttribute('data-ajax-element');

						const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');

						if (elementToGet) {
							const tabContentHtml = responseHTML.querySelector(elementToGet);
							ajaxDataElement.innerHTML = tabContentHtml.innerHTML;
						} else {
							ajaxDataElement.innerHTML = responseText;
						}
					})
					.finally(() => {
						this.activeTabContainer();
						this.classList.add('loaded');
						this.classList.remove('loading');
						this.closest('tpt-tabs-component').classList.remove('component-loading');
					});
			}
		} else {
			if (this.classList.contains('active')) {
				return;
			} else {
				this.activeTabContainer();
			}
		}
	}

	activeTabContainer() {
		const currentTabContainer = this.closest('tpt-tabs-component');
		const tabContainerTarget = this.getAttribute('data-tab-target');

		currentTabContainer.querySelectorAll('tpt-tab-item').forEach((element) => {
			element.classList.remove('active');
		});

		this.classList.add('active');

		currentTabContainer.querySelectorAll('tpt-tab-data').forEach((element) => {
			element.classList.remove('active');
		});

		currentTabContainer.querySelector('[data-tab-container="' + tabContainerTarget + '"]').classList.add('active');
	}
}

customElements.define('tpt-tab-item', TabItem);

/**
 * Accordion component
 */
class AccordionHeader extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('click', this.displayAccordionContainer.bind(this));
		this.addEventListener('keypress', this.keyPress);
	}

	keyPress(e) {
		if (e.key === 'Enter') {
			this.displayAccordionContainer(e);
		}
	}

	displayAccordionContainer(event) {
		event.preventDefault();

		const currentAccordion = this.closest('tpt-accordion-component');
		const currentAccordionItem = this.closest('tpt-accordion-item');

		if (currentAccordion.getAttribute('data-type') == 'group') {
			if (currentAccordionItem.classList.contains('active')) {
				currentAccordionItem.classList.remove('active');
				return;
			} else {
				currentAccordion.querySelectorAll('tpt-accordion-item').forEach((element) => {
					element.classList.remove('active');
				});

				currentAccordionItem.classList.add('active');
				return;
			}
		} else {
			currentAccordionItem.classList.toggle('active');
		}
	}
}

customElements.define('tpt-accordion-title', AccordionHeader);

class ProductGallery extends HTMLElement {
	constructor() {
		super();

		const galleryContainer = this;
		const mainSwiper = this.querySelector('.gallery-main .swiper');
		const mainNext = this.querySelector('.gallery-main .swiper-button-next');
		const mainPrev = this.querySelector('.gallery-main .swiper-button-prev');
		const desktopColumn = parseInt(this.getAttribute('data-desktop-column'));
		const tabletColumn = parseInt(this.getAttribute('data-tablet-column'));
		const mobileColumn = parseInt(this.getAttribute('data-mobile-column'));

		const thumbSwiper = this.querySelector('.gallery-thumb .swiper');
		const thumbNext = this.querySelector('.gallery-thumb .swiper-button-next');
		const thumbPrev = this.querySelector('.gallery-thumb .swiper-button-prev');

		if (this.closest('tpt-modal-component')) {
			var swiperMain = new Swiper(mainSwiper, {
				spaceBetween: 16,
				slidesPerView: 'auto',
				autoHeight: false,
				allowTouchMove: true,
				navigation: {
					nextEl: mainNext,
					prevEl: mainPrev,
				},
				keyboard: {
					enabled: true,
				},
			});
		} else {
			var swiperThumb = new Swiper(thumbSwiper, {
				spaceBetween: 6,
				autoHeight: false,
				allowTouchMove: true,
				navigation: {
					nextEl: thumbNext,
					prevEl: thumbPrev,
				},
				keyboard: {
					enabled: true,
				},
				breakpoints: {
					0: {
						slidesPerView: 6,
						slidesPerGroup: mobileColumn,
					},
					768: {
						slidesPerView: 8,
						slidesPerGroup: tabletColumn,
					},
					1280: {
						slidesPerView: 8,
					},
				},
			});

			var swiperMain = new Swiper(mainSwiper, {
				spaceBetween: 10,
				autoHeight: false,
				allowTouchMove: true,
				navigation: {
					nextEl: mainNext,
					prevEl: mainPrev,
				},
				keyboard: {
					enabled: true,
				},
				breakpoints: {
					0: {
						slidesPerView: mobileColumn,
						slidesPerGroup: mobileColumn,
					},
					768: {
						slidesPerView: tabletColumn,
						slidesPerGroup: tabletColumn,
					},
					1280: {
						slidesPerView: desktopColumn,
						slidesPerGroup: desktopColumn,
					},
				},
				thumbs: {
					swiper: swiperThumb,
				},
			});
		}

		swiperMain.on('transitionEnd', function () {
			window.pauseAllMedia();

			if (mainSwiper.querySelector('.swiper-slide-active')) {
				const slideMediaType = mainSwiper.querySelector('.swiper-slide-active').getAttribute('data-media-type');

				if (slideMediaType == 'video' || slideMediaType == 'model') {
					galleryContainer.classList.add('hidden-lightbox');
					swiperMain.allowTouchMove = false;
				} else {
					galleryContainer.classList.remove('hidden-lightbox');
					swiperMain.allowTouchMove = true;
				}
			}
		});
	}
}

customElements.define('tpt-product-gallery', ProductGallery);

/**
 * Galllery featured product
 */
class ProductGalleryFeatured extends HTMLElement {
	constructor() {
		super();

		const galleryContainer = this;
		const mainSwiper = this.querySelector('.gallery-main .swiper');
		const mainNext = this.querySelector('.gallery-main .swiper-button-next');
		const mainPrev = this.querySelector('.gallery-main .swiper-button-prev');

		var swiperMain = new Swiper(mainSwiper, {
			slidesPerView: 1,
			spaceBetween: 20,
			autoHeight: false,
			allowTouchMove: true,
			navigation: {
				nextEl: mainNext,
				prevEl: mainPrev,
			},
			keyboard: {
				enabled: true,
			},
		});

		swiperMain.on('transitionEnd', function () {
			window.pauseAllMedia();

			if (mainSwiper.querySelector('.swiper-slide-active')) {
				const slideMediaType = mainSwiper.querySelector('.swiper-slide-active').getAttribute('data-media-type');

				if (slideMediaType == 'video' || slideMediaType == 'model') {
					galleryContainer.classList.add('hidden-lightbox');
					swiperMain.allowTouchMove = false;
				} else {
					galleryContainer.classList.remove('hidden-lightbox');
					swiperMain.allowTouchMove = true;
				}
			}
		});
	}
}

customElements.define('tpt-product-gallery-featured', ProductGalleryFeatured);
/**
 * Gallery lightbox
 */

/**
 * Video
 */

class PlayVideo extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', this.playVideo);
	}

	playVideo() {
		const videoId = this.getAttribute('data-poster-id');

		setTimeout(() => {
			document.getElementById(videoId).click();
		}, 300);
	}
}

customElements.define('tpt-play-video', PlayVideo);

/**
 * Open sidebar menu
 */
class TptMenuDrawer extends HTMLElement {
	constructor() {
		super();

		this.defaultColor = this.getAttribute('data-default-color');

		this.addEventListener('click', this.openModal);
		this.addEventListener('keypress', this.keyPress);
	}

	keyPress(e) {
		if (e.key === 'Enter') {
			this.openModal(e);
		}
	}

	openModal(e) {
		e.preventDefault();

		const modalId = this.getAttribute('data-modal-target');
		const modalComponent = document.getElementById(modalId);

		//const btnOpenModal = this;

		if (this.classList.contains('active')) {
			this.classList.remove('active');
			this.setAttribute('aria-expanded', false);
			this.closest('.change-color-header').classList.remove(this.defaultColor);
			document.getElementsByTagName('html')[0].classList.remove('open-modal', 'header-menu-drawer');
			modalComponent.classList.remove('show');

			setTimeout(() => {
				modalComponent.focus();
			}, 300);

			return;
		} else {
			this.classList.add('active');
			this.setAttribute('aria-expanded', true);
			this.closest('.change-color-header').classList.add(this.defaultColor);
			document.getElementsByTagName('html')[0].classList.add('open-modal', 'header-menu-drawer');
			modalComponent.classList.add('show');

			setTimeout(() => {
				modalComponent.focus();
			}, 300);

			return;
		}
	}
}

customElements.define('tpt-menu-drawer', TptMenuDrawer);

/**
 * Copy text to clipboard
 */

var clipboardTimeoout;

class CopyClipboard extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', this.copyClipboard.bind(this));
	}

	copyClipboard() {
		clearTimeout(clipboardTimeoout);

		const text = this.querySelector('.tpt-clipboard__text').value;

		navigator.clipboard.writeText(text);

		this.classList.add('copied');

		clipboardTimeoout = setTimeout(() => {
			this.classList.remove('copied');
		}, 4000);
	}
}

customElements.define('tpt-copy-clipboard', CopyClipboard);

/**
 * Account tab login register
 */

class TptTabAccount extends HTMLElement {
	constructor() {
		super();

		const tabItems = this.querySelectorAll('.tpt-tab-account__list-item');
		const linkChange = this.querySelectorAll('tpt-tab-account-change');
		linkChange.forEach((link) => {
			link.addEventListener('click', this.showTabChange);
		});

		tabItems.forEach((tabItem) => {
			tabItem.addEventListener('click', this.showTab);
		});
	}

	showTabChange() {
		const tabTarget = this.getAttribute('data-customer-target');
		document.querySelector(`tpt-tab-account [data-target="${tabTarget}"]`).click();
	}

	showTab() {
		if (!this.classList.contains('active')) {
			const currentUrl = window.location.href;
			const tabAccountComponent = this.closest('tpt-tab-account');
			const tabDataId = this.getAttribute('data-target');

			console.log(currentUrl);

			if (currentUrl.indexOf('account/login') !== -1) {
				console.log('Page login');
			}

			tabAccountComponent.querySelectorAll('.tpt-tab-account__content').forEach((tabData) => {
				tabData.classList.remove('active');
			});

			tabAccountComponent.querySelectorAll('.tpt-tab-account__list-item').forEach((tabItem) => {
				tabItem.classList.remove('active');
			});

			this.classList.add('active');
			document.getElementById(tabDataId).classList.add('active');
		}
	}
}

customElements.define('tpt-tab-account', TptTabAccount);

/**
 * Check password
 */

function containsUppercase(str) {
	return /[A-Z]/.test(str);
}

function containsLowcase(str) {
	return /[a-z]/.test(str);
}

function containsNumber(str) {
	return /[0-9]/.test(str);
}

class TptPassRequirements extends HTMLElement {
	constructor() {
		super();

		const passInput = this.querySelector('[type="password"]');

		passInput.addEventListener('keyup', this.checkPass);
	}

	checkPass() {
		const passRequirements = this.closest('tpt-pass-requirements');

		let min = false;
		let number = false;
		let uppercase = false;
		let lowercase = false;

		const passString = this.value;
		const buttonSubmit = passRequirements.querySelector('[data-button-submit]');
		const reMin = passRequirements.querySelector('[data-requirements-min]');

		if (passString.length >= 8) {
			min = true;

			if (reMin) {
				reMin.classList.add('active');
			}
		} else {
			min = false;

			if (reMin) {
				reMin.classList.remove('active');
			}
		}

		if (containsUppercase(passString)) {
			uppercase = true;
			passRequirements.querySelector('[data-requirements-uppercase]').classList.add('active');
		} else {
			uppercase = false;
			passRequirements.querySelector('[data-requirements-uppercase]').classList.remove('active');
		}

		if (containsLowcase(passString)) {
			lowercase = true;
			passRequirements.querySelector('[data-requirements-lowercase]').classList.add('active');
		} else {
			lowercase = false;
			passRequirements.querySelector('[data-requirements-lowercase]').classList.remove('active');
		}

		if (containsNumber(passString)) {
			number = true;
			passRequirements.querySelector('[data-requirements-number]').classList.add('active');
		} else {
			number = false;
			passRequirements.querySelector('[data-requirements-number]').classList.remove('active');
		}

		if (min && number && uppercase && lowercase) {
			buttonSubmit.removeAttribute('disabled');
		} else {
			buttonSubmit.setAttribute('disabled', 'disabled');
		}
	}
}

customElements.define('tpt-pass-requirements', TptPassRequirements);

/**
 * Login / Register
 */
if (!customElements.get('tpt-login-register')) {
	customElements.define(
		'tpt-login-register',
		class TptLoginRegister extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.showLoginRegister.bind(this));
			}

			showLoginRegister() {
				const modal = document.getElementById('customer-auth');
				const modalContentTarget = this.getAttribute('data-content');
				const customerFormActive = document.getElementById(modalContentTarget);

				const customerForms = modal.querySelectorAll('.customer-form');

				customerForms.forEach((form) => {
					form.style.display = 'none';
				});

				customerFormActive.style.display = 'block';

				modal.classList.add('show');
				document.getElementsByTagName('html')[0].classList.add('open-modal');
			}
		}
	);
}

/**
 * Slider header top
 */
if (!customElements.get('tpt-slider-header-top')) {
	customElements.define(
		'tpt-slider-header-top',
		class TptSliderHeaderTop extends SwiperSliderComponent {
			constructor() {
				super();

				const documentWidth = document.documentElement.clientWidth;

				if (documentWidth <= 1025) {
					const headerTopSlider = this.querySelector('.swiper-wrapper');
					const announcementItems = document.querySelectorAll('.tpt-announcement-bar__slider .slide-item');

					if (announcementItems) {
						announcementItems.forEach((item) => {
							const slideItem = `<div class="swiper-slide slide-item">${item.innerHTML}</div>`;
							headerTopSlider.insertAdjacentHTML('beforeend', slideItem);
						});
					}
				}
			}
		}
	);
}

/**
 * Dropdown
 */

if (!customElements.get('tpt-dropdown')) {
	customElements.define(
		'tpt-dropdown',
		class TptDropdown extends SwiperSliderComponent {
			constructor() {
				super();

				const button = this.querySelector('tpt-dropdown-button');

				button.addEventListener('click', this.toggleDropdown.bind(this));
			}

			toggleDropdown() {
				this.classList.toggle('active');
			}
		}
	);
}
